import {
    Avatar,
    Text,
    Button,
    TextInput,
    Card,
    Table,
    Modal,
    Switch,
    PasswordInput,
    Select
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import Layout from "../../Layout/Layout";
import { useSelector } from 'react-redux';
import { useForm } from '@mantine/hooks';
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useModals } from '@mantine/modals';

const User = ({ title }) => {

    const modals = useModals();
    const navigate = useNavigate();
    const [opened, setOpened] = useState(false);

    const { userInfo } = useSelector((state) => state.userAccess);

    const form = useForm({
        initialValues: {
            username: userInfo ? userInfo.user.username : '',
            email: userInfo ? userInfo.user.email : '',
            password: '',
            confirmPassword: ''
        },
        errorMessages: {
            username: 'Please re-check the entered email',
            email: 'Please re-check the entered password',

        },
        validationRules: {
            email: (value) => /^\S+@\S+$/.test(value),
        },
    });

    const openConfirmModal = () => {
        modals.openConfirmModal({
            title: 'Confirm Operation',
            centered: true,
            children: (
                <Text size="sm">
                    By clicking confirm, the changes will affect to your account and you will be logged out.
                </Text>
            ),
            labels: { confirm: 'Confirm', cancel: "Close" },
            confirmProps: { color: 'blue' },
            onCancel: () => console.log('cancelled'),
            onConfirm: () => console.log('Confirmed'),
        });
    }



    const handlerUserChange = (values) => {
        console.log(values)
    }

    useEffect(() => {
        if (!userInfo) {
            navigate('/login')
        }
    }, [userInfo, navigate])

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{title}</title>
            </Helmet>
            <Layout activeKey='user'>
                {userInfo && <>
                    <Modal
                        radius='md'
                        opened={opened}
                        onClose={() => setOpened(false)}
                        title="Create New User"
                    >
                        <TextInput
                            radius='md'
                            placeholder="User email"
                            label="Email"
                            required
                        />
                        <TextInput
                            radius='md'
                            sx={{ margin: '10px 0' }}
                            placeholder="User name"
                            label="Username"
                            required
                        />
                        <PasswordInput
                            radius='md'
                            sx={{ margin: '10px 0' }}
                            label="Password"
                            placeholder="User password"
                            required
                        />
                        <Select
                            radius='md'
                            label="Level"
                            placeholder="User Level"
                            data={[
                                { value: 'admin', label: 'Admin' },
                                { value: 'manager', label: 'Manager' },
                                { value: 'worker', label: 'Worker' },
                                { value: 'owner', label: 'Owner' },
                            ]}
                            required
                        />
                        <Button radius='md' sx={{ margin: '20px 0' }} fullWidth loaderPosition="right" variant='filled' color='orange' onClick={() => setOpened(true)}>
                            Create User
                        </Button>
                    </Modal>
                    <Card sx={{ marginBottom: "30px", padding: '30px' }} shadow="sm" radius="md">
                        <span
                            style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: "30px",
                            }}
                        >
                            <Avatar size="lg" radius="md" alt="it's me" color="orange">
                                {userInfo.user.username.charAt(0)}
                            </Avatar>
                            <span style={{ marginLeft: "18px" }}>
                                <Text size="md" weight={700}>{userInfo.user.username}</Text>
                                <Text color="gray">{userInfo.user.role}</Text>
                            </span>
                        </span>
                        <form onSubmit={form.onSubmit((values) => handlerUserChange(values))}>
                            <TextInput
                                {...form.getInputProps('username')}
                                radius='md'
                                sx={{ margin: "18px 0", padding: "0" }}
                                placeholder="Username"
                                label="Your username"
                                required
                            />
                            <TextInput
                                {...form.getInputProps('email')}
                                radius='md'
                                sx={{ margin: "18px 0", padding: "0" }}
                                placeholder="Email"
                                label="Your email"
                                required
                            />
                            <span style={{ display: "flex", justifyContent: "flex-end" }}>
                                <span style={{ padding: "10px" }}>
                                    <Button type='submit' radius='md' color="blue" onClick={openConfirmModal}>Update Profile</Button>
                                </span>
                                <span style={{ padding: "10px 0 10px 10px" }}>
                                    <Button radius='md' color="red">Delete Profile</Button>
                                </span>
                            </span>
                        </form>
                    </Card>
                    <Card shadow="sm" radius="md">
                        <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px' }}>
                            <Text weight={700} size='md'>Users</Text>
                            <Button radius='md' color="orange" onClick={() => setOpened(true)}>Create new User</Button>
                        </span>
                        <Table highlightOnHover>
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Employee Name</th>
                                    <th>Employee Phone</th>
                                    <th>Activate/ Deactivate</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr key="1">
                                    <td>1</td>
                                    <td>John Doe</td>
                                    <td>+94770237111</td>
                                    <td>
                                        <Switch
                                            color='orange'
                                        />
                                    </td>
                                </tr>
                                <tr key="1">
                                    <td>1</td>
                                    <td>John Doe</td>
                                    <td>+94770237111</td>
                                    <td>
                                        <Switch
                                            color='orange'
                                        />
                                    </td>
                                </tr>{" "}
                                <tr key="1">
                                    <td>1</td>
                                    <td>John Doe</td>
                                    <td>+94770237111</td>
                                    <td>
                                        <Switch
                                            color='orange'
                                        />
                                    </td>
                                </tr>{" "}
                                <tr key="1">
                                    <td>1</td>
                                    <td>John Doe</td>
                                    <td>+94770237111</td>
                                    <td>
                                        <Switch
                                            color='orange'
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Card>
                </>}
            </Layout>
        </>
    );
};

export default User;
